import axios from "axios"
export const redirectDomain = async () => {

}
